import ApiClient from './ApiClient';
/* global axios */

class DealsAPI extends ApiClient {
  constructor() {
    super('deals', { accountScoped: true });
  }

  list({
    pipelineId,
    pipelineStageId,
    contactId,
    conversationId,
    q,
    allBranches,
  } = {}) {
    const params = new URLSearchParams();
    if (pipelineId) params.append('pipeline_id', pipelineId);
    if (pipelineStageId) params.append('pipeline_stage_id', pipelineStageId);
    if (contactId) params.append('contact_id', contactId);
    if (conversationId) params.append('conversation_id', conversationId);
    if (q) params.append('q', q);
    // Kanban de Leads: trae todas las sucursales accesibles para los chips de
    // filtro por sucursal (Victor 2026-06-09).
    if (allBranches) params.append('all_branches', '1');
    const qs = params.toString();
    return axios.get(`${this.url}${qs ? `?${qs}` : ''}`);
  }

  moveToStage(dealId, pipelineStageId) {
    return axios.post(`${this.url}/${dealId}/move_to_stage`, {
      pipeline_stage_id: pipelineStageId,
    });
  }

  // Leads en atraso (Retoque/Impresión/Álbum) · modal de Selección al iniciar sesión.
  atrasados() {
    return axios.get(`${this.url}/atrasados`);
  }

  // Solo los atrasos cuyo responsable es el usuario actual · modal 911 al responsable.
  misAtrasados() {
    return axios.get(`${this.url}/mis_atrasados`);
  }

  // Eliminar deal (solo SuperAdmin + Victor Manuel · Victor 2026-05-30).
  destroy(dealId) {
    return axios.delete(`${this.url}/${dealId}`);
  }
}

export default new DealsAPI();
